<div class="bene-card-container" data-cy="decedent-saved-state">
  <div class="bene-card-section">
    <div class="header-container">
      <h2 class="c11n-text-md-bold" [innerHTML]="beneCardData.header"></h2>
      <div class="c11n-text-sm actions">
        <button c11n-link [iconName]="'edit'" [iconPosition]="'leading'"
          (click)="edit()" attr.aria-label="Edit {{beneCardData.header}}"
          [attr.data-cy]="beneCardData.header + 'EditButton'">
          {{content.editLabel}}
        </button>
        @if (showRemoveButton) {
        <button c11n-link [iconName]="'remove'" [iconPosition]="'leading'"
          (click)="remove()" attr.aria-label="Remove {{beneCardData.header}}"
          [attr.data-cy]="beneCardData.header + 'RemoveButton'"
        >
          {{content.removeLabel}}
        </button>
        }
      </div>
    </div>
    @for (row of beneCardData.rows; track row) {
      <div class="show-border">
        <div class="bene-row">
          <p class="row-label" [innerHTML]="row.label"></p>
          <div class="row-values-container">
            <div class="row-value c11n-text-md-bold" [innerHTML]="row.value"></div>
          </div>
        </div>
      </div>
    }
    @for (child of beneCardData.children; track child; let i = $index) {
      <div class="header-container margin-top-2">
        <h2 class="c11n-text-md-bold" innerHTML="Child {{i + 1}}"></h2>
      </div>
      @for (row of child.rows; track row) {
        <div class="show-border">
          <div class="bene-row">
            <p class="row-label" [innerHTML]="row.label"></p>
            <div class="row-values-container">
              <div class="row-value c11n-text-md-bold" [innerHTML]="row.value"></div>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
